<template>
  <v-card v-if="!isMobile" height="100%">
    <v-navigation-drawer>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            Account
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list dense nav>
        <v-list-item v-for="item in items" :key="item.title" :to="{ name: item.route }">
          <v-list-item-icon v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
  export default {
    name: "KidDetailOverviewSideMenu",

    data() {
      return {
        items: [
          {
            index: 0,
            title: "Quests",
            icon: "",
            route: "KidQuests",
          },
          {
            index: 1,
            title: "Profile",
            icon: "",
            route: "KidProfile",
          },
          {
            index: 2,
            title: "Rewards",
            icon: "",
            route: "KidGifts",
          },
        ],
      };
    },

    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.mobile;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Kids/KidDetailOverviewSideMenu.vue